// src/pages/Projects.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { projectsAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import {
  Plus, RefreshCw, Search, Briefcase, Edit2, Trash2, X,
  Calendar, User, Building2, Globe, ChevronLeft, ChevronRight,Filter
} from 'lucide-react';

const PER_PAGE = 25;
import './TimesheetDetail.css';

const STATUT_META = {
  EN_COURS: { label: 'En cours', color: '#16A34A', bg: 'rgba(34,197,94,0.10)' },
  ARCHIVE:  { label: 'Archivé',  color: '#8B8FA8', bg: 'rgba(139,143,168,0.12)' },
};

const DEVISES = ['EUR','USD','GBP','DZD','TND','MAD'];

const RH_ADMIN = ['SUPER_ADMIN','ADMIN','RH'];

const EMPTY_FORM = {
  nom: '', statut: 'EN_COURS', date_debut: '', date_fin: '',
  responsable_id: '', agence: '', client: '', devise: 'EUR',
  adresse: '', code_postal: '', pays: '', commentaire: '',
};

export default function Projects() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const canEdit = RH_ADMIN.includes(user?.role);

  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
 const [filters, setFilters] = useState({
  statut: '',
  client: '',
  agence: '',
  pays: ''
});

const [showFilters, setShowFilters] = useState(false);
  const [page,    setPage]    = useState(1);
  const [modal,   setModal]   = useState(null);
  const [form,    setForm]    = useState(EMPTY_FORM);
  const [saving,  setSaving]  = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const params = { limit: 500 };
      if (search) params.search = search;
     if (filters.statut) params.statut = filters.statut;
if (filters.client) params.client = filters.client;
if (filters.agence) params.agence = filters.agence;
if (filters.pays) params.pays = filters.pays;
      const res = await projectsAPI.list(params);
      setItems(res.data || []);
      setPage(1);
    } catch { toast.error('Erreur chargement projets'); }
    finally { setLoading(false); }
  }, [search, filters]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const openCreate = () => {
    setForm(EMPTY_FORM);
    setModal({ mode: 'create' });
  };

  const openEdit = (e, project) => {
    e.stopPropagation();
    setForm({
      nom:           project.nom || '',
      statut:        project.statut || 'EN_COURS',
      date_debut:    project.date_debut || '',
      date_fin:      project.date_fin || '',
      responsable_id: project.responsable_id || '',
      agence:        project.agence || '',
      client:        project.client || '',
      devise:        project.devise || 'EUR',
      adresse:       project.adresse || '',
      code_postal:   project.code_postal || '',
      pays:          project.pays || '',
      commentaire:   project.commentaire || '',
    });
    setModal({ mode: 'edit', id: project.id });
  };

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm('Supprimer ce projet ?')) return;
    try {
      await projectsAPI.remove(id);
      toast.success('Projet supprimé');
      fetchData();
    } catch { toast.error('Erreur suppression'); }
  };

  const handleSave = async () => {
    if (!form.nom.trim()) { toast.error('Le nom est obligatoire'); return; }
    setSaving(true);
    try {
      const payload = {
        ...form,
        responsable_id: form.responsable_id || null,
        date_debut:     form.date_debut  || null,
        date_fin:       form.date_fin    || null,
        prestations:    [],
      };
      if (modal.mode === 'create') {
        await projectsAPI.create(payload);
        toast.success('Projet créé');
      } else {
        await projectsAPI.update(modal.id, payload);
        toast.success('Projet mis à jour');
      }
      setModal(null);
      fetchData();
    } catch { toast.error('Erreur sauvegarde'); }
    finally { setSaving(false); }
  };

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));
const hasFilters = Object.values(filters).some(Boolean);
  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1>Projets</h1>
          <p>Projets clients et internes — affectation des ressources</p>
        </div>
        <div className="page-header-actions">
          <button
  className="btn btn-secondary"
  onClick={() => setShowFilters(s => !s)}
>
  <Filter size={15}/>
  Filtres

  {hasFilters && (
    <span
      style={{
        marginLeft:4,
        background:'#FF4100',
        color:'white',
        borderRadius:'50%',
        width:16,
        height:16,
        display:'inline-flex',
        alignItems:'center',
        justifyContent:'center',
        fontSize:'0.6rem'
      }}
    >
      {Object.values(filters).filter(Boolean).length}
    </span>
  )}
</button>

<button className="btn btn-secondary" onClick={fetchData}>
  <RefreshCw size={15}/>
</button>
          {canEdit && (
            <button className="btn btn-primary" onClick={openCreate}>
              <Plus size={15}/> Nouveau projet
            </button>
          )}
        </div>
      </div>

      {/* Filtres */}
      {/* Recherche */}
<div style={{ display:'flex', gap:10, marginBottom:16 }}>
  <div style={{ position:'relative', flex:1 }}>
    <Search
      size={14}
      style={{
        position:'absolute',
        left:10,
        top:'50%',
        transform:'translateY(-50%)',
        color:'var(--text-muted)'
      }}
    />

    <input
      style={{
        paddingLeft:34,
        height:38,
        border:'1px solid var(--border)',
        borderRadius:8,
        width:'100%'
      }}
      placeholder="Nom du projet, client..."
      value={search}
      onChange={e => setSearch(e.target.value)}
    />
  </div>

  {(search || hasFilters) && (
    <button
      className="btn btn-ghost btn-sm"
      onClick={() => {
        setSearch('');
        setFilters({
          statut:'',
          client:'',
          agence:'',
          pays:''
        });
      }}
    >
      <X size={14}/>
      Réinitialiser
    </button>
  )}
</div>

{showFilters && (
  <div className="card" style={{ marginBottom:16, padding:'14px 16px' }}>
    <div
      style={{
        display:'grid',
        gridTemplateColumns:'repeat(4,1fr)',
        gap:10
      }}
    >
      <div>
        <label style={lbl}>Statut</label>

        <select
          className="filter-select"
          style={{ width:'100%' }}
          value={filters.statut}
          onChange={e =>
            setFilters(p => ({
              ...p,
              statut:e.target.value
            }))
          }
        >
          <option value="">Tous</option>

          {Object.entries(STATUT_META).map(([k,v]) => (
            <option key={k} value={k}>
              {v.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label style={lbl}>Client</label>

        <input
          style={inp}
          value={filters.client}
          placeholder="Client..."
          onChange={e =>
            setFilters(p => ({
              ...p,
              client:e.target.value
            }))
          }
        />
      </div>

      <div>
        <label style={lbl}>Agence</label>

        <input
          style={inp}
          value={filters.agence}
          placeholder="Agence..."
          onChange={e =>
            setFilters(p => ({
              ...p,
              agence:e.target.value
            }))
          }
        />
      </div>

      <div>
        <label style={lbl}>Pays</label>

        <input
          style={inp}
          value={filters.pays}
          placeholder="Pays..."
          onChange={e =>
            setFilters(p => ({
              ...p,
              pays:e.target.value
            }))
          }
        />
      </div>
    </div>
  </div>
)}


      {/* Pagination info */}
      {!loading && items.length > 0 && (() => {
        const totalPages = Math.ceil(items.length / PER_PAGE);
        const start = (page - 1) * PER_PAGE + 1;
        const end   = Math.min(page * PER_PAGE, items.length);
        return (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
            <span style={{ fontSize:'0.8125rem', color:'var(--text-muted)' }}>
              {start}–{end} sur {items.length} projet{items.length !== 1 ? 's' : ''}
            </span>
            {totalPages > 1 && (
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <button className="btn btn-ghost btn-sm" onClick={() => setPage(p => Math.max(1,p-1))} disabled={page===1}>
                  <ChevronLeft size={14}/>
                </button>
                {Array.from({length:totalPages},(_,i)=>i+1).map(p => (
                  <button key={p} onClick={() => setPage(p)} className="btn btn-ghost btn-sm"
                    style={{ fontWeight: p===page ? 700 : 400, color: p===page ? '#FF4100' : undefined,
                      background: p===page ? 'rgba(255,65,0,0.08)' : undefined, minWidth:28 }}>
                    {p}
                  </button>
                ))}
                <button className="btn btn-ghost btn-sm" onClick={() => setPage(p => Math.min(totalPages,p+1))} disabled={page===totalPages}>
                  <ChevronRight size={14}/>
                </button>
              </div>
            )}
          </div>
        );
      })()}

      {/* Liste */}
      {loading ? (
        <div className="loading-state"><div className="spinner"/></div>
      ) : items.length === 0 ? (
        <div className="card" style={{ textAlign:'center', padding:'48px 0' }}>
          <Briefcase size={36} style={{ opacity:0.3, marginBottom:12 }}/>
          <div style={{ fontWeight:600, marginBottom:6 }}>Aucun projet</div>
          <div style={{ fontSize:'0.875rem', color:'var(--text-muted)', marginBottom:20 }}>
            Créez votre premier projet
          </div>
          {canEdit && (
            <button className="btn btn-primary" onClick={openCreate}><Plus size={15}/> Créer</button>
          )}
        </div>
      ) : (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Projet</th>
                  <th>Client</th>
                  <th>Statut</th>
                  <th>Agence</th>
                  <th>Période</th>
                  <th>Ressources</th>
                  {canEdit && <th/>}
                </tr>
              </thead>
              <tbody>
                {items.slice((page-1)*PER_PAGE, page*PER_PAGE).map(p => {
                  const sm = STATUT_META[p.statut] || STATUT_META.EN_COURS;
                  return (
                    <tr key={p.id} onClick={() => navigate('/projects/' + p.id)} style={{ cursor:'pointer' }}>
                      <td>
                        <div style={{ fontWeight:600, fontSize:'0.875rem' }}>{p.nom}</div>
                        {p.pays && (
                          <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', display:'flex', alignItems:'center', gap:4, marginTop:2 }}>
                            <Globe size={11}/> {p.pays}
                          </div>
                        )}
                      </td>
                      <td style={{ fontSize:'0.8125rem' }}>{p.client || <span style={{ color:'var(--text-faint)' }}>—</span>}</td>
                      <td>
                        <span className="badge" style={{ color:sm.color, background:sm.bg, border:`1px solid ${sm.color}33` }}>
                          {sm.label}
                        </span>
                      </td>
                      <td style={{ fontSize:'0.8125rem' }}>
                        {p.agence
                          ? <span style={{ display:'flex', alignItems:'center', gap:4 }}><Building2 size={12}/>{p.agence}</span>
                          : <span style={{ color:'var(--text-faint)' }}>—</span>}
                      </td>
                      <td style={{ fontSize:'0.8rem', color:'var(--text-muted)' }}>
                        {p.date_debut && <div style={{ display:'flex', alignItems:'center', gap:4 }}><Calendar size={11}/>{fmt(p.date_debut)}</div>}
                        {p.date_fin   && <div style={{ color:'var(--text-faint)', paddingLeft:15 }}>→ {fmt(p.date_fin)}</div>}
                        {!p.date_debut && !p.date_fin && <span style={{ color:'var(--text-faint)' }}>—</span>}
                      </td>
                      <td>
                        {p.prestations?.length > 0 ? (
                          <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
                            {p.prestations.slice(0,3).map(pr => (
                              <span key={pr.id} style={{
                                fontSize:'0.7rem', padding:'2px 7px', borderRadius:8,
                                background:'rgba(255,65,0,0.08)', color:'#FF8F6A',
                                border:'1px solid rgba(255,65,0,0.20)',
                              }}>
                                {pr.resource_prenom} {pr.resource_nom}
                              </span>
                            ))}
                            {p.prestations.length > 3 && (
                              <span style={{ fontSize:'0.7rem', color:'var(--text-faint)' }}>
                                +{p.prestations.length - 3}
                              </span>
                            )}
                          </div>
                        ) : <span style={{ color:'var(--text-faint)', fontSize:'0.8rem' }}>—</span>}
                      </td>
                      {canEdit && (
                        <td>
                          <div style={{ display:'flex', gap:4 }}>
                            <button className="btn btn-ghost btn-sm" onClick={e => openEdit(e, p)} title="Modifier">
                              <Edit2 size={13}/>
                            </button>
                            <button className="btn btn-ghost btn-sm" onClick={e => handleDelete(e, p.id)} title="Supprimer"
                              style={{ color:'var(--danger-600)' }}>
                              <Trash2 size={13}/>
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal création / édition */}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-card" style={{ width: 600, maxHeight:'90vh', overflowY:'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0 }}>{modal.mode === 'create' ? 'Nouveau projet' : 'Modifier le projet'}</h3>
              <button className="btn btn-ghost btn-sm" onClick={() => setModal(null)}><X size={16}/></button>
            </div>

            <div className="form-grid">
              {/* Nom */}
              <div className="form-group" style={{ gridColumn:'1/-1' }}>
                <label className="form-label">Nom du projet *</label>
                <input className="form-control" value={form.nom} onChange={set('nom')} placeholder="Ex: Projet transformation digitale…"/>
              </div>

              {/* Client */}
              <div className="form-group">
                <label className="form-label">Client</label>
                <input className="form-control" value={form.client} onChange={set('client')} placeholder="Nom du client"/>
              </div>

              {/* Statut */}
              <div className="form-group">
                <label className="form-label">Statut</label>
                <select className="form-control" value={form.statut} onChange={set('statut')}>
                  <option value="EN_COURS">En cours</option>
                  <option value="ARCHIVE">Archivé</option>
                </select>
              </div>

              {/* Dates */}
              <div className="form-group">
                <label className="form-label">Date de début</label>
                <input type="date" className="form-control" value={form.date_debut} onChange={set('date_debut')}/>
              </div>
              <div className="form-group">
                <label className="form-label">Date de fin</label>
                <input type="date" className="form-control" value={form.date_fin} onChange={set('date_fin')}/>
              </div>

              {/* Agence */}
              <div className="form-group">
                <label className="form-label">Agence / Site</label>
                <select className="form-control" value={form.agence} onChange={set('agence')}>
                  <option value="">— Sélectionner —</option>
                  <option value="FRANCE">France</option>
                  <option value="BELGIQUE">Belgique</option>
                  <option value="ALGERIE">Algérie</option>
                  <option value="TUNISIE">Tunisie</option>
                </select>
              </div>

              {/* Devise */}
              <div className="form-group">
                <label className="form-label">Devise</label>
                <select className="form-control" value={form.devise} onChange={set('devise')}>
                  {DEVISES.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>

              {/* Pays */}
              <div className="form-group">
                <label className="form-label">Pays</label>
                <input className="form-control" value={form.pays} onChange={set('pays')} placeholder="Ex: France"/>
              </div>

              {/* Adresse + CP */}
              <div className="form-group">
                <label className="form-label">Adresse</label>
                <input className="form-control" value={form.adresse} onChange={set('adresse')} placeholder="Adresse"/>
              </div>
              <div className="form-group">
                <label className="form-label">Code postal</label>
                <input className="form-control" value={form.code_postal} onChange={set('code_postal')} placeholder="75001"/>
              </div>

              {/* Commentaire */}
              <div className="form-group" style={{ gridColumn:'1/-1' }}>
                <label className="form-label">Commentaire</label>
                <textarea className="form-control" rows={3} value={form.commentaire} onChange={set('commentaire')}
                  placeholder="Notes, contexte, besoin…" style={{ resize:'vertical' }}/>
              </div>
            </div>

            <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:20, borderTop:'1px solid var(--border)', paddingTop:16 }}>
              <button className="btn btn-secondary" onClick={() => setModal(null)}>Annuler</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving || !form.nom.trim()}>
                {saving ? 'Sauvegarde…' : modal.mode === 'create' ? 'Créer le projet' : 'Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function fmt(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

const lbl = {
  display:'block',
  fontSize:'0.75rem',
  fontWeight:600,
  color:'var(--text-muted)',
  marginBottom:4,
  textTransform:'uppercase',
  letterSpacing:'0.04em'
};

const inp = {
  width:'100%',
  padding:'8px 10px',
  border:'1.5px solid var(--border)',
  borderRadius:7,
  fontSize:'0.875rem',
  boxSizing:'border-box',
  fontFamily:'inherit',
  outline:'none',
  background:'var(--bg-elevated)',
  color:'var(--text-primary)'
};
